import { DollarSign, Calendar, CreditCard } from "react-feather";

export const OrganizationLabel = {
  Title: "Organization",
  ListTitle: "Organization List",
  Name: "Organization Name",
  Description: "Description",
  Remark: "Manage your organizations",
  AddOrganization: "Add Organization",
  EditOrganization: "Edit Organization",
  DeleteOrganization: "Delete Organization",
  OvertimePolicyType: "Overtime Policy Type",
  OvertimePolicyTypeDesc: "Choose how overtime is compensated for staff in this organisation",
  PayrollType: "Payroll System Type",
  PayrollTypeDesc: "Select whether to enable structured payroll calculation or use a flat salary",
};

export const OVERTIME_POLICY_TYPE = {
  PAYMENT: "overtime_payment",
  COMPOFF: "compoff_leave",
};

export const overtimePolicyTypeOptions = [
  {
    value: OVERTIME_POLICY_TYPE.PAYMENT,
    label: "Overtime Payment",
    description: "Staff receive monetary compensation for overtime hours worked",
    Icon: DollarSign,
    color: "#10b981",
    bg: "rgba(16,185,129,0.08)",
    border: "rgba(16,185,129,0.25)",
  },
  {
    value: OVERTIME_POLICY_TYPE.COMPOFF,
    label: "Comp-Off Leave Credit",
    description: "Staff earn compensatory leave credits in exchange for overtime hours",
    Icon: Calendar,
    color: "#6366f1",
    bg: "rgba(99,102,241,0.08)",
    border: "rgba(99,102,241,0.25)",
  },
];

export const payrollTypeOptions = [
  {
    value: true,
    label: "Enable Payroll",
    description: "Use dynamic payroll templates with allowances, deductions, and structures",
    Icon: DollarSign,
    color: "#10b981",
    bg: "rgba(16,185,129,0.08)",
    border: "rgba(16,185,129,0.25)",
  },
  {
    value: false,
    label: "Flat Salary",
    description: "Pay staff a fixed flat salary amount without complex payroll calculations",
    Icon: CreditCard,
    color: "#f59e0b",
    bg: "rgba(245,158,11,0.08)",
    border: "rgba(245,158,11,0.25)",
  },
];
